import React from "react"
import Link from "gatsby-link"

export default function ButtonPurple(props) {
  return (
    <>
      {props.onClick && (
        <button onClick={props.onClick} className="c-button c-button--purple">
          <span className="c-button__text">{props.text}</span>
        </button>
      )}

      {props.to && (
        <Link
          to={props.to}
          className="c-button c-button--purple"
          activeClassName="-active"
        >
          <span className="c-button__text">{props.text}</span>
        </Link>
      )}
    </>
  )
}
